import { useState, useEffect } from 'react';

type UseModalOptions = {
  onOpen?: () => void;
  onClose?: () => void;
  lockBody?: boolean;
};

export const useModal = (initialState = false, options?: UseModalOptions) => {
  const [isOpen, setIsOpen] = useState(initialState);
  const lockBody = options?.lockBody ?? false;

  useEffect(() => {
    if (!lockBody || !isOpen) return;

    const html = document.documentElement;
    const body = document.body;
    const sidemenu = document.querySelector('.l-sidemenu');

    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    if (sidemenu) {
      (sidemenu as HTMLElement).style.position = 'unset';
    }

    return () => {
      html.style.overflow = '';
      body.style.overflow = '';
      if (sidemenu) {
        (sidemenu as HTMLElement).style.position = 'sticky';
      }
    };
  }, [isOpen, lockBody]);

  const open = () => {
    setIsOpen(true);
    options?.onOpen?.();
  };

  const close = () => {
    setIsOpen(false);
    options?.onClose?.();
  };

  const toggle = () => {
    setIsOpen(prev => {
      const next = !prev;
      if (next) {
        options?.onOpen?.();
      } else {
        options?.onClose?.();
      }
      return next;
    });
  };

  return { isOpen, open, close, toggle };
};
